var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C15.3137 12.5 18 9.81371 18 6.5C18 3.18629 15.3137 0.5 12 0.5C8.68629 0.5 6 3.18629 6 6.5C6 9.81371 8.68629 12.5 12 12.5Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.4991C7.03172 14.5046 3.00553 18.5308 3 23.4991C3 24.0514 3.4477 24.4991 3.99998 24.4991H20C20.5522 24.4991 21 24.0514 21 23.4991C20.9945 18.5308 16.9683 14.5046 12 14.4991Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.b2a90cef297d9ad7a95502180280da01.svg";
export { ForwardRef as ReactComponent };